import Controller from "csi/action/Controller";
import monitor from "csi/monitor/_base";
import declare from "dojo/_base/declare";

export = declare(Controller, {
	/**
	 * @override
	 * Refresh view when ProofWorkflow node get updated
	 */
	onStart() {
		const document = this.getNode();
		const documentRevision = this.m_cache.getNode(document.CurrentRevision);
		const handle = monitor.onChangeNode(documentRevision.ProofWorkflow, (node) => {
			this.widget.refreshWidget();
			handle.remove();
		});
	},
});